import { render, staticRenderFns } from "./IconUpload.vue?vue&type=template&id=40fc5847&"
import script from "./IconUpload.vue?vue&type=script&lang=js&"
export * from "./IconUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40fc5847')) {
      api.createRecord('40fc5847', component.options)
    } else {
      api.reload('40fc5847', component.options)
    }
    module.hot.accept("./IconUpload.vue?vue&type=template&id=40fc5847&", function () {
      api.rerender('40fc5847', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconUpload.vue"
export default component.exports